import { LazyComponentImportCallback } from './types';

type ThenArgRecursive<T> =
  T extends PromiseLike<infer U> ? { 0: ThenArgRecursive<U>; 1: U }[T extends PromiseLike<any> ? 0 : 1] : T;

/**
 * Обертка над коллбеком, возвращающим промис.
 * В результирующем коллбеке есть свойство со значением последнего вызова.
 * Позволяет кешировать последнее значение для повторной отрисовки LazyComponent без ререндера
 */
export const createImportCallback = <G, T extends Promise<G>>(
  fn: () => T,
): LazyComponentImportCallback<ThenArgRecursive<T>> => {
  const cb: any = () =>
    fn().then((result) => {
      cb.cache = { result };
      return result;
    });

  return cb;
};
